function Svg({ className = 'h-5 w-5', children, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconDashboard(props) {
  return (
    <Svg {...props}>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
    </Svg>
  );
}

export function IconCandidates(props) {
  return (
    <Svg {...props}>
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <circle cx="12" cy="10.5" r="2.4" />
      <path d="M7.5 17c.7-2.3 2.4-3.5 4.5-3.5s3.8 1.2 4.5 3.5" />
    </Svg>
  );
}

export function IconUsers(props) {
  return (
    <Svg {...props}>
      <circle cx="9" cy="8.5" r="3" />
      <path d="M3.5 19.5c.7-3.4 2.9-5.2 5.5-5.2s4.8 1.8 5.5 5.2" />
      <circle cx="17.5" cy="9" r="2.2" />
      <path d="M15.8 14.4c2 .4 3.3 1.9 3.7 4.6" />
    </Svg>
  );
}

export function IconShieldCheck(props) {
  return (
    <Svg {...props}>
      <path d="M12 3l7 3v5c0 4.6-2.9 8.4-7 10-4.1-1.6-7-5.4-7-10V6l7-3z" />
      <path d="M9 12l2 2 4-4" />
    </Svg>
  );
}

export function IconWorkflow(props) {
  return (
    <Svg {...props}>
      <circle cx="5" cy="6" r="2" />
      <circle cx="19" cy="6" r="2" />
      <circle cx="12" cy="18" r="2" />
      <path d="M5 8v2a4 4 0 0 0 4 4h1" />
      <path d="M19 8v2a4 4 0 0 0-4 4h-1" />
    </Svg>
  );
}

export function IconReports(props) {
  return (
    <Svg {...props}>
      <path d="M4 20V10" />
      <path d="M11 20V4" />
      <path d="M18 20v-7" />
      <path d="M3 20h18" />
    </Svg>
  );
}

export function IconActivity(props) {
  return (
    <Svg {...props}>
      <path d="M3 12h4l2-6 4 12 2-6h6" />
    </Svg>
  );
}

export function IconClock(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4l3 2" />
    </Svg>
  );
}

export function IconCheckCircle(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M8.5 12.5l2.5 2.5 4.5-5" />
    </Svg>
  );
}

export function IconXCircle(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M9.5 9.5l5 5" />
      <path d="M14.5 9.5l-5 5" />
    </Svg>
  );
}

export function IconPanelToggle(props) {
  return (
    <Svg {...props}>
      <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
      <path d="M9.5 4.5v15" />
    </Svg>
  );
}

export function IconChevronDown(props) {
  return (
    <Svg {...props}>
      <path d="M6 9.5l6 6 6-6" />
    </Svg>
  );
}

export function IconChevronRight(props) {
  return (
    <Svg {...props}>
      <path d="M9.5 6l6 6-6 6" />
    </Svg>
  );
}

export function IconLeads(props) {
  return (
    <Svg {...props}>
      <path d="M4 5.5h16" />
      <path d="M4 12h10" />
      <path d="M4 18.5h6" />
      <path d="M16 15.5l3.5 3.5L21 17.5" />
    </Svg>
  );
}

export function IconMasters(props) {
  return (
    <Svg {...props}>
      <path d="M12 3.5l7.5 4.3v8.4L12 20.5l-7.5-4.3V7.8L12 3.5z" />
      <circle cx="12" cy="12" r="2.6" />
    </Svg>
  );
}

// Keyed by route path — used by Sidebar to resolve a nav item's icon.
export const NAV_ICONS = {
  '/': IconDashboard,
  '/candidates': IconCandidates,
  '/leads': IconLeads,
  '/users': IconUsers,
  '/roles': IconShieldCheck,
  '/workflow': IconWorkflow,
  '/reports': IconReports,
  '/activity-log': IconActivity,
  '/masters': IconMasters,
  default: IconDashboard,
};
